/* eslint-disable @typescript-eslint/no-unused-vars */
import { Span } from "../../common/Span";
import { Button } from "../../common/Button";
import Up from "../../assets/img/config_up_bg.png";
import Down from "../../assets/img/403.png";
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="bg-getgreen-5">
      <img src={Up} alt={Up} className="up" />
      <img src={Down} alt={Down} className="down" />

      <div className="min-h-screen flex items-center text-center justify-center">
        <div className="mx-6">
          <Span size="3xl" color="white" padding="none">
            Sorry, the page you visited does not exist.
          </Span>
          <div className="mt-10">
            <Button
              margin="top"
              weight="semi"
              onClick={() => window.location.reload()}
            >
              Refresh
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
